module.exports = __webpack_public_path__ + "static/media/banner-re2-lg.c6b82a49.png";